import script from "./PaymentReportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentReportForm.vue?vue&type=script&setup=true&lang=js"

import "./PaymentReportForm.vue?vue&type=style&index=0&id=20d83c40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d83c40"]])

export default __exports__